import dayjs from "dayjs";
import { useDiaryContext } from "./useDiaryContext";
import { setDiaryNote } from "../APIs/Venue/diaryNote";

/**
 * Shared hook for DiaryNoteViewer logic
 * Extracts note content and save handler to avoid duplication
 */
export const useDiaryNote = () => {
  const { venueConfig, date, setDiaryContext } = useDiaryContext();

  const noteContent =
    venueConfig?.daily_venue_notes?.[
      dayjs(date).format("YYYY-MM-DD") ?? ""
    ]?.replace(/<[^>]*?>/g, "") ?? "";

  const onSaveNote = async (content: string) => {
    const dateKey = dayjs(date).format("YYYY-MM-DD") ?? "";
    if (!dateKey || !venueConfig) {
      return;
    }

    // Save to backend API
    const response = await setDiaryNote({
      venueId: venueConfig._id,
      diaryNoteDate: dateKey,
      diaryNote: content
    });

    if (!response) {
      return;
    }

    // Extract notes from payload (API response only contains notes, not date)
    const savedNotes = response.payload?.notes || response.notes || "";

    // Update local context with saved data
    // Use the dateKey we sent in the request since API doesn't return it
    const updatedVenueConfig = {
      ...venueConfig,
      daily_venue_notes: {
        ...venueConfig.daily_venue_notes,
        [dateKey]: savedNotes
      }
    };

    setDiaryContext({ venueConfig: updatedVenueConfig });
  };

  return {
    noteContent,
    onSaveNote,
    date
  };
};
